module.exports = __webpack_public_path__ + "d521b53c4c079a83cfc31a8882427180.pdf";